import { render, staticRenderFns } from "./PixEditView.vue?vue&type=template&id=669c8b53&scoped=true&"
import script from "./PixEditView.vue?vue&type=script&lang=ts&"
export * from "./PixEditView.vue?vue&type=script&lang=ts&"
import style0 from "./PixEditView.vue?vue&type=style&index=0&id=669c8b53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669c8b53",
  null
  
)

export default component.exports